import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SvgImageUpload = ({ className, ...restProps }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('svg', 'svg-empty-avatar', className)}
    {...restProps}>
    <path
      d="M18.6003 25.0001C22.1349 25.0001 25.0003 22.1347 25.0003 18.6C25.0003 15.0654 22.1349 12.2 18.6003 12.2C15.0656 12.2 12.2002 15.0654 12.2002 18.6C12.2002 22.1347 15.0656 25.0001 18.6003 25.0001Z"
      stroke="#0055FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6001 15.4009V21.8009"
      stroke="#0055FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4004 18.6003H21.8005"
      stroke="#0055FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.00007 21.8002H2.60001C2.17566 21.8002 1.76869 21.6316 1.46863 21.3316C1.16857 21.0315 1 20.6245 1 20.2002V2.60001C1 2.17566 1.16857 1.76869 1.46863 1.46863C1.76869 1.16857 2.17566 1 2.60001 1H13.9377C14.3618 1.00009 14.7684 1.16852 15.0684 1.46827L18.1319 4.53177C18.4316 4.83171 18.6001 5.23839 18.6002 5.66244V9.00007"
      stroke="#0055FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.80039 6.19971C5.87951 6.19971 5.95684 6.22317 6.02262 6.26712C6.0884 6.31107 6.13967 6.37355 6.16995 6.44664C6.20022 6.51973 6.20815 6.60015 6.19271 6.67775C6.17728 6.75534 6.13918 6.82661 6.08324 6.88256C6.0273 6.9385 5.95602 6.97659 5.87843 6.99203C5.80084 7.00746 5.72041 6.99954 5.64732 6.96927C5.57423 6.93899 5.51176 6.88772 5.4678 6.82194C5.42385 6.75616 5.40039 6.67882 5.40039 6.59971C5.40039 6.49362 5.44253 6.39188 5.51755 6.31687C5.59256 6.24185 5.69431 6.19971 5.80039 6.19971Z"
      stroke="#0055FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2979 10.7607L12.2003 9.00071C12.1282 8.8923 12.0307 8.80313 11.9164 8.74098C11.802 8.67883 11.6741 8.64557 11.5439 8.64409C11.4138 8.64262 11.2852 8.67298 11.1694 8.73253C11.0537 8.79208 10.9542 8.87902 10.8797 8.98578L8.74637 12.0269L7.43223 10.9741C7.34566 10.9047 7.2456 10.854 7.13842 10.8254C7.03124 10.7968 6.91927 10.7907 6.80962 10.8077C6.69998 10.8246 6.59506 10.8642 6.50154 10.9239C6.40801 10.9836 6.32792 11.062 6.26635 11.1543L4.2002 15.4008H9.00024"
      stroke="#0055FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgImageUpload.propTypes = {
  className: PropTypes.string,
};

export default SvgImageUpload;
